<template>
  <v-app fill-height class="knots-background">
    <v-main>
      <router-view />
      <v-snackbar
        bottom
        v-if="alert.show"
        v-model="alert.show"
        :color="alert.color"
        :timeout="alert.timeout || 3000"
      >
        {{ $t(alert.text) }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  name: 'App',

  computed: mapState(['alert']),

  updated() {
    this.checkCurrentLogin();
  },

  methods: {
    checkCurrentLogin() {
      if (!localStorage.authorization && !this.$route.meta.public) {
        this.$router.push(`/sign_in?redirect=${this.$route.path}`);
      }
    },
  },

};
</script>

<style lang="scss">

:root {
  @each $color, $value in $colors {
    @each $variant, $hexcode in $value {
      --v-#{$color}-#{$variant}: #{$hexcode};
    }
  }
  --app-body-font-family: #{$body-font-family};
}

.bottom-dialog {
  margin: 0px 0px !important;
  align-self: flex-end;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}

.z-100 {
  z-index: 100;
}

.sticky-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  padding-left: 24px;
  padding-right: 24px;
  width: 100vw;
  z-index: 150;
  border: 1px solid transparent;
}

.sticky-bottom-confirm {
  position: fixed;
  left: 0px;
  padding-left: 34px;
  padding-right: 36px;
  width: 100vw;
  z-index: 150;
  border: 1px solid transparent;
}

@media only screen and (max-width: 600px) {
  .sticky-bottom-confirm {
    position: fixed;
    bottom: 56px;
    left: 0px;
    padding-left: 34px;
    padding-right: 36px;
    width: 100vw;
    z-index: 150;
    border: 1px solid transparent;
  }
}

.px-36 {
  padding-left: 144px !important;
  padding-right: 144px !important;
}

#app .py-md-20{
  @media only screen and (min-width: 960px) {
    padding-left: 144px !important;
    padding-right: 144px !important;
  }
}

.mx-33 {
  margin-left: 132px !important;
  margin-right: 132px !important;
}

#app .mx-md-33 {
  @media only screen and (min-width: 960px) {
    margin-left: 132px !important;
    margin-right: 132px !important;
  }
}

.py-20 {
  padding-top: 80px !important;
  padding-bottom: 80px !important;
}

#app .py-md-20{
  @media only screen and (min-width: 960px) {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
}

.mb-20 {
  margin-bottom: 80px !important;
}

#app .mb-md-20{
  @media only screen and (min-width: 960px) {
    margin-bottom: 80px !important;
  }
}

.mr-24 {
  margin-right: 94px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mt-29 {
  margin-top: 116px !important;
}

.mt-20 {
  margin-top: 80px !important;
}

.pl-30 {
  padding-left: 120px !important;
}

.v-dialog {
  box-shadow: none !important;
}

.container-presentational {
  max-width: none!important;
}

.w-auto {
  width: auto !important;
}

svg {
  font-size: 16px;
}

.z-200 {
  z-index: 200;
}

#app .mb-md-50 {
  @media only screen and (min-width: 960px) {
    margin-bottom: 50px !important;
  }
}

.knots-background {
  background-image: url('./assets/knots.svg') !important;
  background-repeat: no-repeat !important;
  background-size: auto !important;
  background-position-x: calc(100vw - 175px) !important;
  background-position-y: -70px !important;
  background-color: var(--v-neutral-tone-100) !important;

  @media only screen and (min-width: 960px) {
    background-position: calc(100vw - 250px) -60px !important;
  }

  @media only screen and (min-width: 1500px) {
    background-position: calc(100vw - 250px) -30px !important;
  }

  @media only screen and (min-width: 2000px) {
    background-position: calc(100vw - 450px) -30px !important;
  }
}
</style>
